import { cloneElement } from 'react';
import type { FunctionComponent, ReactElement } from 'react';

import AccessGate from '../../generic/Gates/AccessGate';
import { RouterProps } from '../../../types';

const ProjectHistoryPage: FunctionComponent<RouterProps> = (props) => (
  <div>
    <div className="container margin-top">
      <AccessGate level="free">{cloneElement(props.children as ReactElement, props)}</AccessGate>
    </div>
  </div>
);

export default ProjectHistoryPage;
